/** Match the response parser: the outer body counts toward the eight multipart levels. */
export const MAX_MULTIPART_NESTING = 8;
